import Vue from 'vue'
import App from './App.vue'
import router from './router'

import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import List from './components/List.vue' // TODO @?
import VueHotkey from 'v-hotkey'

Vue.use(VueHotkey)
Vue.use(BootstrapVue);

Vue.config.productionTip = false

new Vue({
	components: {
		List
	},
	router,
	render: h => h(App)
}).$mount('#app')
